import Modal from 'views/components/UI/Modal'
import { H3, H5 } from 'views/components/UI/Text'
import { BackButton, Button } from 'views/components/UI/Buttons'
import { ButtonsContainer, ModalContent, ModalHeader, TrashIconBig, TrashIconWhite } from './styled'
import TrashIconSmall from 'assets/images/trash-icon-white.png'
import TrashIconRed from 'assets/images/trash-icon-big.png'

export interface ModalQuestionsProps {
  showModal: boolean
  handleClose: () => void
  handleCleanup: () => void
}

const ModalCleanup: React.FC<ModalQuestionsProps> = ({ showModal, handleClose, handleCleanup }) => {
  return (
    <Modal
      show={showModal}
      setShow={handleClose}
      hideCloseButton
      styleContent={{
        maxWidth: '80vw',
        minWidth: '900px',
        maxHeight: 'auto',
        padding: '20px',
        margin: '0',
      }}
    >
      <ModalContent style={{ alignItems: 'center' }}>
        <ModalHeader style={{ alignItems: 'center', justifyContent: 'center' }}>
          <TrashIconBig src={TrashIconRed} alt="Trash Icon" />
          <H3>¿Seguro que deseas salir del proceso?</H3>
          <H5 style={{ fontWeight: '400' }}>
            Si continúas, perderás toda la información ingresada y los ítems asociados.
          </H5>
        </ModalHeader>
        <ButtonsContainer>
          <BackButton text="Cancelar" hideIcon onClick={handleClose} />
          <Button
            onClick={handleCleanup}
            type="button"
            style={{ width: 'fit-content', display: 'flex', alignItems: 'center', gap: '20px' }}
          >
            <TrashIconWhite src={TrashIconSmall} />
            Salir
          </Button>
        </ButtonsContainer>
      </ModalContent>
    </Modal>
  )
}

export default ModalCleanup
